
export const converToNumberFormat = (n: number | string) => {
  const _window: any = window;
  return _window.numeral(n).format('0,0');
};
